import { createFileRoute } from '@tanstack/react-router'
import AppsPage from '@/components/pages/AppsPage/AppsPage'
import { z } from 'zod'

const appsSearchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
  filter: z.string().optional(),
  sort: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/apps/')({
  validateSearch: (search) => appsSearchSchema.parse(search),
  component: AppsRoute,
})

function AppsRoute() {
  return <AppsPage />
}
